/*
 * Name: Ticked List
 * Component: global
 * Props:
 */
import React from "react"
import * as styles from "./TickedList.module.scss"

const TickedList = (props) => (
  <section className={styles.TickedList}>
    <h3>{props.title}</h3>
    <div className={styles.list}>
      {props.list.map((item, i) => (
        <div className={styles.item} key={i}>
          <img src={props.tick} alt="tick" />
          <span>{item.service ? item.service : item.subservice}</span>
        </div>
      ))}
    </div>
  </section>
)

export default TickedList
